import React, { Component } from 'react';
import { Breadcrumb } from 'antd';
import { Link, withRouter } from 'react-router-dom';

const breadcrumbNameMap: any = {

    '/qrcode': '二维码',

    '/institution': '机构设置',
    '/institution/edit': '编辑信息',
    '/institution/changePassword': '修改密码',

    '/customerList': '用户管理',
    '/customerList/detail': '用户详情',
    '/customerList/dataTrend': '数据趋势',
    '/customerList/reportContrast': '报告对比',

    '/statistics': '统计报表',
    '/customerList/reportDetail': '报告详情',

};

class BreadcrumbCustom extends Component {
    
    constructor(props: any) {
        super(props);
    }

    state = {
        pathSnippets: [],
        breadcrumbItems: {}
    }

    getPath() {
        const { history }: any = this.props;
        let pathname = history.location.pathname;
        
        this.state['pathSnippets'] = pathname.split('/').filter((i: any) => i);
        this.state['breadcrumbItems'] = this.state['pathSnippets'].map((_: any, index: any) => {
            const url = `/${this.state['pathSnippets'].slice(0, index + 1).join('/')}`;
            const length = this.state['pathSnippets'].length;
            if( index + 1 === length || index === 1) {    
                return (
                    <Breadcrumb.Item key={url}>
                        {breadcrumbNameMap[url]}
                    </Breadcrumb.Item>
                );
            } else {
                return (
                    <Breadcrumb.Item key={url}>
                        <Link to={url}>
                            {breadcrumbNameMap[url]}
                        </Link>
                    </Breadcrumb.Item>
                );
            }
        });
    }
 
    componentWillMount() {
        this.getPath();
    }
    componentWillReceiveProps(){
        this.getPath();  
    }
    render() {
        return (
            <span>
                <Breadcrumb>
                    {this.state['breadcrumbItems']}
                </Breadcrumb> 
            </span>
        )
    }
}
export default withRouter(BreadcrumbCustom)
